import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class SplahGuard implements CanActivate {
  constructor(
    private storageSv:StorageService,
    private router: Router
  ){}
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean>{
    const lang = await this.storageSv.get('langage');
    if(!lang){
      this.router.navigate(['/splash']);
    }
    return true;
  }
  
}
